import React, { useCallback, useEffect, useRef, useState } from "react";
import Header2 from "../components/Header2";
import Header from "../components/Header";

import Cropper from "react-easy-crop";
import Modal from "react-bootstrap/Modal";

// Helper function to crop the image

const getCroppedImg = async (imageSrc, crop, zoom) => {
  const image = new Image();
  image.src = imageSrc;
  await new Promise((resolve) => (image.onload = resolve));

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const scale = zoom;
  const cropWidth = 300; // Adjust based on your cropper's width
  const cropHeight = 300; // Adjust based on your cropper's height

  canvas.width = cropWidth;
  canvas.height = cropHeight;

  ctx.translate(-crop.x * scale, -crop.y * scale);
  ctx.scale(scale, scale);
  ctx.drawImage(image, 0, 0);

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      const fileUrl = URL.createObjectURL(blob);
      resolve(fileUrl);
    }, "image/jpeg");
  });
};

function UserProfile() {
  //   // State to track if the user is logged in
  //   const [isLoggedIn, setIsLoggedIn] = useState(false);

  //   // Function to handle login (you can replace this with your actual login logic)
  //   const handleLogin = () => {
  //     setIsLoggedIn(true);
  //   };

  //   // Function to handle logout
  //   const handleLogout = () => {
  //     setIsLoggedIn(false);
  //   };

  //   const [selectedImage, setSelectedImage] = useState(null);
  //   const fileInputRef = useRef(null);

  //   const handleButtonClick = () => {
  //     if (fileInputRef.current) {
  //       fileInputRef.current.click();
  //     }
  //   };

  //   const handleFileChange = (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         setSelectedImage(reader.result); // Set the selected image as a base64 URL
  //       };
  //       reader.readAsDataURL(file); // Read the file as a data URL
  //     }
  //   };

  //   UseEffect

  const [activeSection, setActiveSection] = useState("followers");

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImage = localStorage.getItem("profileImage");
    if (storedImage) {
      setSelectedImage(storedImage);
    }
  }, []);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("profileImage", reader.result); // Save to localStorage
        localStorage.removeItem("croppedImage"); // Clear previous cropped image
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [brightness, setBrightness] = useState(0);

  const handleEditPhoto = () => {
    if (selectedImage) {
      setShowModal(true); // Open modal only if there's an uploaded photo
    } else {
      alert("Please upload a photo first.");
    }
  };

  // Load image from local storage if available
  // useEffect(() => {
  //   const savedImage = localStorage.getItem("croppedImage");
  //   if (savedImage) {
  //     setSelectedImage(savedImage);
  //   }
  // }, []);

  useEffect(() => {
    const savedImage = localStorage.getItem("croppedImage");

    if (savedImage) {
      setSelectedImage(savedImage);
    }

    // else {
    //   alert("No image found. Please upload an image.");
    // }
  }, []);

  const handleSave = useCallback(async () => {
    const croppedImage = await getCroppedImg(selectedImage, crop, zoom);
    setSelectedImage(croppedImage);
    setShowModal(false); // Close modal after saving

    // Save the cropped image to local storage
    localStorage.setItem("croppedImage", croppedImage);
  }, [selectedImage, crop, zoom]);

  // Spared NAm,e is updated
  const [isEditing, setIsEditing] = useState(false); // To toggle edit mode
  const [name, setName] = useState(
    () => localStorage.getItem("profileName") || "Paul Smith"
  ); // Initialize with saved name); // Default name

  const handleNameChange = (e) => {
    setName(e.target.value); // Update name state when input changes
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing); // Toggle between view and edit mode
  };

  const saveName = () => {
    setIsEditing(false); // Exit edit mode
    // Optionally, save the updated name to localStorage or an API
    localStorage.setItem("profileName", name);
  };

  return (
    <>
      {/* Conditionally render Header or Header2 based on login status */}
      {/* {isLoggedIn ? (
        <Header2 onLogout={handleLogout} />
      ) : (
        <Header onLogin={handleLogin} />
      )} */}
      <Header2 />

      <div className="container">
        <div className="row mb-5 ">
          <div className="d-md-flex justify-content-center   ">
            <div className="col-md-4  textsmctr col-6 mx-auto  mt-5">
              {/* Header */}
              <div className="d-sm-flex  gap-3 gap-md-4">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChange} // Handle file change
                />
                <img
                  src={
                    selectedImage || require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="119"
                  height="119"
                  //   style={{ width: "118px", height: "118px" }} // Set dimensions as needed
                  onClick={handleButtonClick} // Allow clicking on the image to upload a new one
                />

                <div
                  className="mt-sm-5 fw-bold fs-4 ftzpual text-dark"
                  style={{ lineHeight: "33.6px" }}
                >
                  {isEditing ? (
                    <input
                      type="text"
                      value={name}
                      onChange={handleNameChange}
                      onBlur={saveName} // Save name when the input loses focus
                      className="form-control"
                      style={{ width: "auto" }}
                      autoFocus // Automatically focus on the input when in edit mode
                    />
                  ) : (
                    <div onClick={toggleEdit} style={{ cursor: "pointer" }}>
                      {name}
                    </div>
                  )}
                </div>

                {/* <div
                  className="mt-sm-5 fw-bold fs-4 ftzpual text-dark "
                  style={{ lineHeight: "33.6px" }}
                >
                  Paul Smith
                </div> */}
              </div>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChange} // Handle file change
                />
                <button
                  type="button"
                  className="btn btnwid btn-secondary fs-5 fw-normal w-100 mt-4"
                  style={{
                    backgroundColor: "#888888",
                    maxWidth: "184px",
                    height: "44px",
                    border: "1px solid #383838",
                    lineHeight: "27.24px",
                  }}
                  onClick={handleButtonClick}
                >
                  Change Photo
                </button>
              </div>

              <div>
                <button
                  type="button"
                  className="btn btnwid btn-secondary fs-5 fw-normal w-100 mt-3"
                  style={{
                    backgroundColor: "#888888",
                    maxWidth: "184px",
                    height: "44px",
                    border: "1px solid #383838",
                    lineHeight: "27.24px",
                  }}
                  onClick={handleEditPhoto}
                >
                  Edit Profile
                </button>

                <Modal show={showModal} onHide={() => setShowModal(false)}>
                  <Modal.Header closeButton>Edit Profile</Modal.Header>
                  <Modal.Body>
                    {selectedImage && (
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "300px",
                        }}
                      >
                        <Cropper
                          image={selectedImage}
                          crop={crop}
                          zoom={zoom}
                          aspect={1}
                          onCropChange={setCrop}
                          onZoomChange={setZoom}
                          style={{
                            filter: `brightness(${brightness}%)`,
                          }}
                        />
                      </div>
                    )}
                    <div className="mt-3">
                      <label>Brightness</label>
                      <input
                        type="range"
                        min="50"
                        max="150"
                        value={brightness}
                        onChange={(e) => setBrightness(e.target.value)}
                      />
                    </div>

                    {/* Name Input Field */}
                    <div className="mt-3">
                      <label>Name</label>
                      <input
                        type="text"
                        value={name}
                        onChange={handleNameChange}
                        onBlur={saveName}
                        // onChange={(e) => setName(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btnwid btn-secondary fs-5 fw-normal w-100 mt-3"
                      style={{
                        backgroundColor: "#888888",
                        maxWidth: "184px",
                        height: "44px",
                        border: "1px solid #383838",
                        lineHeight: "27.24px",
                      }}
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btnwid btn-secondary fs-5 fw-normal w-100 mt-3"
                      style={{
                        backgroundColor: "#888888",
                        maxWidth: "184px",
                        height: "44px",
                        border: "1px solid #383838",
                        lineHeight: "27.24px",
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>

            <div className="col-md-8 col-12 margintop ">
              {/* BorderLine Event */}

              <div className="d-flex  justify-content-center  gap-3 gap-lg-5 mt-5">
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "298px",
                    border: "1.4px solid #704949",

                    height: "1.4px",
                  }}
                ></div>

                <div
                  className="fzevnt1  text-center fw-normal  fs-6 text-center"
                  style={{
                    color: "#3C3C3C",

                    lineHeight: "27.24px",
                    marginTop: "-13px",
                  }}
                >
                  Event & connections
                </div>
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "298px",
                    border: "1.4px solid #704949",

                    height: "1.4px",
                  }}
                ></div>
              </div>

              {/* Event & Connections */}
              <div className="col-12 mt-4">
                <div className="d-flex flex-wrap gap-3 justify-content-center">
                  <div
                    className="text-center  maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "160px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center ftzevtt  fs-5 text-dark "
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Following <br />
                      24
                    </div>
                  </div>

                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "160px",
                      height: "94px",

                      cursor: "pointer",
                      border:
                        activeSection === "followers"
                          ? "1px solid #E33629"
                          : "1px solid transparent",
                    }}
                  >
                    <div
                      className={` ${
                        activeSection === "followers"
                      } text-center fs-5 text-dark ftzevtt `}
                      onClick={() => setActiveSection("followers")}
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Followers <br />
                      12
                    </div>
                  </div>

                  <div
                    className={` ${
                      activeSection === "events"
                    } text-center maaxwbg p-2 w-100 rounded-3`}
                    onClick={() => setActiveSection("events")}
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "160px",
                      height: "94px",
                      cursor: "pointer",
                      border:
                        activeSection === "events"
                          ? "1px solid #E33629"
                          : "1px solid transparent",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Next events <br />1
                    </div>
                  </div>

                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "160px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Past events <br />
                      24
                    </div>
                  </div>

                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "160px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      1:1 events <br />
                      24
                    </div>
                  </div>
                </div>
              </div>

              {/*Again BorderLine Event */}

              <div className="d-flex  justify-content-center gap-3 gap-lg-5 margintop">
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "298px",
                    border: "1.4px solid #704949",

                    height: "1.4px",
                  }}
                ></div>

                <div
                  className="fzevnt1  text-center fw-normal  fs-6 text-center"
                  style={{
                    color: "#3C3C3C",

                    lineHeight: "27.24px",
                    marginTop: "-13px",
                  }}
                >
                  Event & connections
                </div>
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "298px",
                    border: "1.4px solid #704949",

                    height: "1.4px",
                  }}
                ></div>
              </div>

              {/* again Event & Connections */}
              <div className="col-12 mt-3">
                <div className="d-flex flex-wrap gap-4 justify-content-center">
                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "200.75px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Reviews <br />
                      24
                    </div>
                  </div>

                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "200.75px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Currently Reading <br />
                      12
                    </div>
                  </div>

                  <div
                    className="text-center maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "200.75px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      To Read <br />1
                    </div>
                  </div>

                  <div
                    className="text-center mxwsg maaxwbg p-2 w-100 rounded-3"
                    style={{
                      backgroundColor: "#E9E9E9",
                      maxWidth: "180px",
                      height: "94px",
                    }}
                  >
                    <div
                      className="text-center fs-5 text-dark ftzevtt"
                      style={{ fontWeight: "600", lineHeight: "40px" }}
                    >
                      Read <br />
                      24
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Conditional Rendering Based on Active Section */}

          {/* Followers Section */}

          {activeSection === "followers" && (
            <div className="col-12 mt-3 mt-sm-5">
              <div
                className=" mt-5 fs-4 ftzpual"
                style={{
                  fontWeight: "600",
                  color: "#3B3B3B",
                  lineHeight: "33.6px",
                }}
              >
                Followers
              </div>

              <div className="d-flex flex-wrap gap-4 gap-lg-0 justify-content-center mt-3  margleft1">
                <div className="text-center mx-3 ">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/paulsmithf.png")}
                      alt="Follower"
                      className="rounded-circle pualimgwid "
                    />
                    <div
                      className="mt-4 fw-bold ftzpual "
                      style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                    >
                      Paul Smith
                    </div>
                  </div>
                </div>
                <div className="text-center mx-3">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/paulsmithf.png")}
                      alt="Follower"
                      className="rounded-circle pualimgwid "
                    />
                    <div
                      className="mt-4 fw-bold ftzpual"
                      style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                    >
                      Paul Smith
                    </div>
                  </div>
                </div>
                <div className="text-center mx-3">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/paulsmithf.png")}
                      alt="Follower"
                      className="rounded-circle pualimgwid "
                    />
                    <div
                      className="mt-4 fw-bold ftzpual"
                      style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                    >
                      Paul Smith
                    </div>
                  </div>
                </div>
                <div className="text-center mx-3">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/paulsmithf.png")}
                      alt="Follower"
                      className="rounded-circle pualimgwid "
                    />
                    <div
                      className="mt-4 fw-bold ftzpual"
                      style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                    >
                      Paul Smith
                    </div>
                  </div>
                </div>
                <div className="text-center mx-3">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/paulsmithf.png")}
                      alt="Follower"
                      className="rounded-circle pualimgwid "
                    />
                    <div
                      className="mt-4 fw-bold ftzpual"
                      style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                    >
                      Paul Smith
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Next Event Section */}
          {activeSection === "events" && (
            <div className="col-12 mt-3 mt-sm-5">
              <div
                className=" mt-5 fs-4 ftzpual"
                style={{
                  fontWeight: "600",
                  color: "#3B3B3B",
                  lineHeight: "33.6px",
                }}
              >
                Next Events
              </div>

              <div className="d-flex  flex-wrap gap-5  mt-3  ">
                <div className=" mx-lg-0 mx-auto ">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/bookevent.png")}
                      alt="Follower"
                      className=" eventimgwid "
                    />

                    <div>
                      <div
                        className="my-1 fw-bold ftzpual "
                        style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                      >
                        Abroad in Japan
                      </div>
                      <div
                        className=" fw-normal textleft fs-5 ftzpual "
                        style={{ lineHeight: "40px" }}
                      >
                        Fiction
                      </div>

                      <div
                        className=" mt-2 mt-lg-0 fw-bold  fs-5 ftzpual "
                        style={{ lineHeight: "40px", color: "#34C3C9" }}
                      >
                        Wed, Oct 20 - 7:00 pm
                      </div>

                      <div
                        className="  mt-2 mt-lg-0  fs-5 ftzpual  text-dark"
                        style={{ lineHeight: "40px", fontWeight: "600" }}
                      >
                        20-30 age
                      </div>

                      <div
                        className="mt-1  mt-2 mt-lg-0 fw-bold  fs-5 ftzpual text-dark "
                        style={{ lineHeight: "40px" }}
                      >
                        Group event
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" mx-lg-5 mx-auto ">
                  <div className="d-flex gap-3">
                    <img
                      src={require("../pages/image/bookevent.png")}
                      alt="Follower"
                      className=" eventimgwid "
                    />
                    <div>
                      <div
                        className="my-1 fw-bold ftzpual "
                        style={{ fontSize: "22.31px ", lineHeight: "30.39px" }}
                      >
                        Abroad in Japan
                      </div>
                      <div
                        className=" fw-normal textleft fs-5 ftzpual "
                        style={{ lineHeight: "40px" }}
                      >
                        Fiction
                      </div>

                      <div
                        className=" mt-2 mt-lg-0 fw-bold  fs-5 ftzpual "
                        style={{ lineHeight: "40px", color: "#34C3C9" }}
                      >
                        Wed, Oct 20 - 7:00 pm
                      </div>

                      <div
                        className=" mt-2 mt-lg-0  fs-5 ftzpual  text-dark"
                        style={{ lineHeight: "40px", fontWeight: "600" }}
                      >
                        20-30 age
                      </div>

                      <div
                        className="mt-2 mt-lg-0 mt-1 fw-bold  fs-5 ftzpual text-dark "
                        style={{ lineHeight: "40px" }}
                      >
                        Group event
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default UserProfile;
